import { Component, OnInit } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-leaderboard-page',
  templateUrl: './leaderboard-page.component.html',
  styleUrls: ['./leaderboard-page.component.scss'],
})
export class LeaderboardPageComponent implements OnInit {
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;

  constructor() {}

  ngOnInit() {}
}
